<template>
	<div class="mid_scroll_content scrollbar mt-0">
		<section class="pb-4 border-0 wenlocomScreen-top">
			<div class="row">
				<div class="container">
					<div class="customWith-addd addpadBottom-res" v-if="parseInt(get_user.lead_type) == 0">
						<div class="section_title"><h5>Finish setting up your Capital Wallet account </h5></div>
						<div class="welcomeBlock d-flex align-items-start justify-content-between">
							<div class="successCheck">
								<feather type="check-circle"></feather>
							</div>
							<div class="blockSection">
								<h4>Tier 1 Verification</h4>
								<!-- <p>You are verified to trade crypto worth $500. Add funds to make your first trade.</p> -->
								<p>Your email has been verified. You can now deposit upto 1 BTC</p>
								<div class="addFunds d-flex mt-4">
									<router-link class="cap_btn blue" to="/wallets">Add funds</router-link>
								</div>
							</div>
							
						</div>
						<div class="welcomeBlock d-flex align-items-start justify-content-between">
							<div class="successCheck">
								<feather type="check-circle" v-if="parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) >= 3 || parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) >= 4"></feather>
								<feather class="notCompleted" type="alert-triangle" v-else></feather>
							</div>
							<div class="blockSection">
								<h4>Tier 2 Verification</h4>
								<p v-if="parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) >= 3 || parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) >= 4">Tier 2 verification success Text</p>
								<!-- <p v-else>Continue verification for higher funding limits</p> -->
								<p v-else>Upload identity documents to avail higher funding limits.</p>
								<div class="addFunds d-flex mt-4">
									<router-link :to="'/individual-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) < 3">Upgrade</router-link>
									<router-link :to="'/corporate-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4">Upgrade</router-link>
								</div>
							</div>
						</div>
						<div class="welcomeBlock d-flex align-items-start justify-content-between">
							<div class="successCheck">
								<feather type="check-circle" v-if="GetPaymentMethods.length > 0"></feather>
								<feather class="notCompleted" type="alert-triangle" v-else></feather>
							</div>
							<div class="blockSection">
								<h4>Fund Your Account</h4>
								<p>Deposit fiat currencies to trade (AUD, USD, GBP & Euro)</p>
								<div class="addFunds d-flex mt-4">
									<!-- <router-link class="cap_btn blue" :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'1'}}">Add Bank</router-link> -->
									<router-link :to="'/individual-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) < 3">Add Bank</router-link>
									<router-link :to="'/corporate-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4">Add Bank</router-link>
								</div>
							</div>
							
						</div>
					</div>
					<div class="customWith-addd addpadBottom-res" v-if="parseInt(get_user.lead_type) == 1">
						<div class="section_title"><h5>Finish setting up your Capital Wallet account </h5></div>
						<div class="welcomeBlock d-flex align-items-start justify-content-between">
							<div class="successCheck">
								<feather class="notCompleted" type="alert-triangle"></feather>
							</div>
							<div class="blockSection">
								<h4>Complete Verification</h4>
								<p>Upload documents related to your business, your intended use of the account and the ownership of business</p>
								<div class="addFunds d-flex mt-4">
									<router-link :to="'/corporate-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4">Start Now</router-link>
								</div>
							</div>
							
						</div>
						<div class="welcomeBlock d-flex align-items-start justify-content-between">
							<div class="successCheck">
								<feather class="notCompleted" type="alert-triangle"></feather>
							</div>
							<div class="blockSection">
								<h4>Convert your crypto</h4>
								<p>Convert your coins at industry low processing fees of only 0.5%</p>
								<div class="addFunds d-flex mt-4">
									<router-link class="cap_btn blue" :to="'/exchange'">Exchange Now</router-link>
								</div>
							</div>
						</div>
						<div class="welcomeBlock d-flex align-items-start justify-content-between">
							<div class="successCheck">
								<feather class="notCompleted" type="alert-triangle"></feather>
							</div>
							<div class="blockSection">
								<h4>Use our API</h4>
								<p>Accept Cryptocurrency payments with Capital Wallet API</p>
								<div class="addFunds d-flex mt-4">
									<router-link class="cap_btn blue" :to="'/exchange'" :class="(parseInt(get_user.tier) > 2)? '' : 'disabled'">Devloper Options</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- <section id="portfolio" class="pb-4 border-0 wenlocomScreen-max">
			<div class="row align-items-center">
				<div class="col-12">
					<div class="imgFlow">
						<img src="../../../../static/website/images/winning_concept.svg" alt="Icon">
					</div>
				</div>
				<div class="col-12">
					<div class="welcomeuserDetails">
						<div class="media">
						  <div class="media-body">
						    <div class="section_title_welcome mb-0"><h5>👏 Welcome To {{$env_var.productName}}</h5></div>
						    <p>Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.</p>
						    <div class="dashBoard-block">
								<router-link :to="'/individual-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) < 3">Upgrade Now</router-link>
								<router-link :to="'/corporate-step'+(parseInt(get_user.step)+1)" class="cap_btn blue" v-if="parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4">Upgrade Now</router-link>
						    </div>
						  </div>
						</div>
					</div>	
				</div>=
			</div>
		</section> -->
		
	</div>

   
</template>

<script>
import { depositWithdrawalMixins } from '@/plugins/depositWithdrawal'
export default {
    name: 'welcome',
	mixins: [depositWithdrawalMixins],
    data() {
        return {

        }
    },
	
	created(){
		this.pageName('Welcome')
		this._runGetPaymentMethods({ 'globalParams' :{ },'localParams' :{"parameter" : this}})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/user/welcome.vue